export default {
  state: {
    snackbar: false,
    snackbarProps: {
      y: 'bottom',
      x: null,
      mode: '',
      timeout: 6000,
      color: '',
      text: 'Snackbar messages'
    }
  },
  getters: {
    showSnackbar: state => {
      return state.snackbar
    },
    snackbarProps: state => {
      return state.snackbarProps
    }
  },
  mutations: {
    showNotification (state, val) {
      state.snackbar = val
    },
    notificationProps (state, props) {
      state.snackbarProps = props
    }
  },
  actions: {
    sendNotification: ({commit}, newNotification) => {
      commit('showNotification', false)
      let defaultNotification = {
        y: 'bottom',
        x: null,
        mode: '',
        timeout: 6000,
        color: '',
        text: 'You have refreshed the application.'
      }
      setTimeout(() => {
        for (var attrname in newNotification) { defaultNotification[attrname] = newNotification[attrname] }
        commit('notificationProps', defaultNotification)
        commit('showNotification', true)
      }, 250)
    },
    closeNotification: ({commit}) => {
      commit('showNotification', false)
    }
  }
}
